import { useStore } from '../../Context';
import useTheme from '../../hooks/useTheme'

const CUOTITAS_ATTEMPTS = process.env.REACT_APP_CUOTITAS_ATTEMPTS || 5;
const CUOTAYA_ATTEMPTS = process.env.REACT_APP_CUOTAYA_ATTEMPTS || 5;

export default function Navigation() {
    const { stepBackwards, step } = useStore();
    const attempts = localStorage.getItem('attempts');
    const theme = useTheme()  

    const themeAttempts = theme === 'cuotitas' ? CUOTITAS_ATTEMPTS : CUOTAYA_ATTEMPTS
    const showAttempts = Number(themeAttempts) !== 0
  
    function handleBack () {
        if (step === 1) return;
        stepBackwards();
    };

    return (
        <nav className='page-navigation'>
            <button className="button-transparent" onClick={handleBack}>
                <img src='/arrow-left.svg' alt='' width="20" /><span>Volver</span>
            </button>
            {(step !== 7 && showAttempts) && (
                <span className='attempts'>Te {Number(attempts) === 1 ? 'queda' : 'quedan'} {attempts} {Number(attempts) === 1 ? 'intento' : 'intentos'}</span>
            )}
        </nav>
    );
}